import { gql } from '@apollo/client'

export const MARK_CASE_EMAIL_IRRELEVANT_MUTATION = gql`
  mutation MarkCaseEmailIrrelevant($emailId: ID!) {
    markCaseEmailIrrelevant(emailId: $emailId) {
      caseEmail {
        id
      }
      errors
    }
  }
`
